// Turns a favorite place ({ address, geojson }) into the point the address fields work with.
// GeoJSON stores [lon, lat]; the form wants lat/lon. Returns null when there are no coordinates.
export const favoriteToStop = (favorite) => {
  const coordinates = favorite?.geojson?.coordinates;
  if (!coordinates || coordinates.length < 2) return null;
  return { name: favorite.address, lat: coordinates[1], lon: coordinates[0] };
};
